import { render, staticRenderFns } from "./scene1Pc.vue?vue&type=template&id=e4d9a9d6&scoped=true&"
import script from "./scene1Pc.vue?vue&type=script&lang=js&"
export * from "./scene1Pc.vue?vue&type=script&lang=js&"
import style0 from "./scene1Pc.vue?vue&type=style&index=0&id=e4d9a9d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d9a9d6",
  null
  
)

export default component.exports